/*
 * Кластеры платформы на главной: окружение, домен, сводка приложений ArgoCD,
 * ссылки на сервисы. Данные приходят из useResources (общие со сводкой и остальными).
 */
import { AsyncState } from 'react-use/esm/useAsync';
import { routes } from '../../lib/viva';
import { ArgoAppsSummary } from '../argocd';
import { AsyncCell } from '../catalog/cells';
import { clusterColumns } from '../catalog/columns';
import { KubernetesIcon } from '../icons';
import { ResourceCard } from './ResourceCard';
import { ClusterRow, Resources } from './useResources';

const columns = clusterColumns<ClusterRow>(row => (
  <AsyncCell state={row.apps} unavailable="ArgoCD недоступен">
    {apps => <ArgoAppsSummary apps={apps ?? []} />}
  </AsyncCell>
));

export const DeployedClustersCard = ({
  resources,
}: {
  resources: AsyncState<Resources>;
}) => (
  <ResourceCard<ClusterRow>
    icon={<KubernetesIcon />}
    title="Кластеры"
    to={routes.clusters}
    linkText="все кластеры"
    columns={columns}
    rows={resources.value?.clusters}
    loading={resources.loading}
    error={resources.error}
    errorTitle="Не удалось загрузить кластеры"
    emptyText="Кластеров пока нет — создайте первый из шаблона «Новый Kubernetes-кластер»."
    createText="Новый кластер"
    createTo={routes.newCluster}
  />
);
